import {Component, Injector} from "@angular/core";
import {
    AbstractSelectSearchControlComponent
} from "../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {registerSearchControl} from "../../framework/entity/search/search-controls/abstract-search-control.component";

@Component({
    selector: "wbo-bi-sale-type-multi-select-search-control",
    templateUrl: "../../framework/entity/search/search-controls/select-search-controls/multi-select-search-control.component.html",
    providers: [
        registerSearchControl(SaleTypeMultiSelectSearchControlComponent)
    ]
})
export class SaleTypeMultiSelectSearchControlComponent extends AbstractSelectSearchControlComponent<any> {
    constructor(injector: Injector) {
        super(undefined, injector);

        this.buildData([
            {label: "wbo.bi.search.option.sale-type.regular", value: "Regular"},
            {label: "wbo.bi.search.option.sale-type.table", value: "Table"},
            {label: "wbo.bi.search.option.sale-type.tab", value: "Tab"},
            {label: "wbo.bi.search.option.sale-type.refund", value: "Refund"},
            {label: "wbo.bi.search.option.sale-type.outgoings", value: "Outgoings"},
            {label: "wbo.bi.search.option.sale-type.delivery", value: "Delivery"},
            {label: "wbo.bi.search.option.sale-type.takeaway", value: "Takeaway"},
            {label: "wbo.bi.search.option.sale-type.drivethru", value: "Drive Thru"},
            {label: "wbo.bi.search.option.sale-type.cashout", value: "Cash Out"},
            {label: "wbo.bi.search.option.sale-type.quote", value: "Quote"},
            {label: "wbo.bi.search.option.sale-type.online", value: "Online"},
            {label: "wbo.bi.search.option.sale-type.tableapp", value: "Table (App)"}
        ]);
    }
}
